import { render, staticRenderFns } from "./UploadQuotation.vue?vue&type=template&id=d1d2872c&scoped=true&"
import script from "./UploadQuotation.vue?vue&type=script&lang=js&"
export * from "./UploadQuotation.vue?vue&type=script&lang=js&"
import style0 from "./UploadQuotation.vue?vue&type=style&index=0&id=d1d2872c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d2872c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VIcon,VRow})
